import React, { BaseSyntheticEvent, useEffect } from 'react';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import { theme } from '../../constants/theme';

import Logo from '../../assets/Logo/MainLogo.png';
import { Link } from '../../ui/Link';
import { availableLanguages } from '../../i18n';

const Wrapper = styled.div`
  background-color: ${theme.colors.blackColor};
  padding-top: 36px;
`;

const Header = styled.div`
  background-color: ${theme.colors.blackColor};
  height: 76px;
  display: flex;
  flex-direction: row;
  padding: 0 10%;
  align-items: center;
  justify-content: space-between;
`;

const LinkWrapper = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none !important;
`;

const MainLogo = styled.img`
  height: 36px;
`;

const LanguageWrapper = styled.div``;

const MainTitle = styled.h4`
  color: ${({ theme }) => theme.colors.whiteColor};
  text-decoration: none;
`;

const LanguageTitle = styled(MainTitle)`
  cursor: pointer;
`;

const NavBar: React.FC<{}> = () => {
  const {
    i18n,
    i18n: { language },
  } = useTranslation();
  const languageToSelect = availableLanguages.filter(
    (lang: string) => lang !== language
  );
  
  const changeLanguage = (element: BaseSyntheticEvent) => {
    const toChange = element.target.innerText.toLowerCase();
    Cookies.set('userLang', toChange);
    i18n.changeLanguage(toChange);
  }; 

  useEffect(() => {    
    if (!Cookies.get('userLang')) Cookies.set('userLang', language);
  }, [])

  return (
    <Wrapper>
      <Header>
        <LinkWrapper href='/'>
          <MainLogo src={Logo} />
          <MainTitle>eAsig</MainTitle>
        </LinkWrapper>
        <LanguageWrapper>
          <LanguageTitle onClick={changeLanguage}>
            {languageToSelect[0].toLocaleUpperCase()}
          </LanguageTitle>
        </LanguageWrapper>
      </Header>
    </Wrapper>
  );
};

export default NavBar;
